import React from 'react';

const isWarningFuelState = (state) => {
    const normalized = String(state || '').toLowerCase();
    return normalized.includes('refuel') || normalized.includes('low');
};

const FuelStateBadge = ({ state }) => {
    if (!state) {
        return null;
    }

    const className = isWarningFuelState(state)
        ? 'fuel-state-badge fuel-state-badge--warning'
        : 'fuel-state-badge';

    return (
        <span className={className}>
            {state}
        </span>
    );
};

export default FuelStateBadge;
